import { Instagram } from "lucide-react";
import { Logo } from "./Logo";
import { Reveal } from "./Services";
import { scrollToId } from "./Nav";

export function ContactCTA({ onOrder }) {
  return (
    <section id="contato" className="border-t border-line bg-paper2 py-20 sm:py-32 lg:py-40" data-testid="contact-section">
      <div className="mx-auto max-w-[1400px] px-6 text-center sm:px-12 lg:px-20">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-ink-3">04 — Contato</p>
          <h2 className="mx-auto mt-6 max-w-3xl font-display text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl">
            Vamos dar vida <span className="text-butter">à sua ideia?</span>
          </h2>
          <p className="mx-auto mt-6 max-w-md text-base text-ink-2">
            Monte seu pedido em minutos. Depois, todo o contato acontece pelo seu e-mail e WhatsApp.
          </p>
          <button
            data-testid="contact-order-cta-button"
            onClick={onOrder}
            className="btn-lift mt-10 rounded-full bg-ink px-10 py-5 font-mono text-[11px] uppercase tracking-[0.2em] text-paper hover:bg-accent"
          >
            Fazer pedido agora
          </button>
        </Reveal>
      </div>
    </section>
  );
}

export default function Footer() {
  return (
    <footer className="border-t border-line py-14" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-12 lg:px-20">
        <div className="flex flex-wrap items-center justify-between gap-8">
          <Logo />
          <nav className="flex flex-wrap gap-6">
            {["servicos", "processo", "estudio"].map((id) => (
              <button
                key={id}
                data-testid={`footer-link-${id}`}
                onClick={() => scrollToId(id)}
                className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-2 transition-colors hover:text-accent"
              >
                {id}
              </button>
            ))}
            <a
              href="https://www.instagram.com/essenzaabr"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram-link"
              className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-ink-2 transition-colors hover:text-accent"
            >
              <Instagram className="h-3.5 w-3.5" /> @essenzaabr
            </a>
          </nav>
        </div>
        <div className="mt-10 flex flex-wrap items-center justify-between gap-4 border-t border-line pt-8">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-3">
            © {new Date().getFullYear()} Essenza — Studio de Design Gráfico
          </p>
          <a
            href="/admin"
            data-testid="footer-admin-link"
            className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-3 transition-colors hover:text-accent"
          >
            Painel do estúdio
          </a>
        </div>
      </div>
    </footer>
  );
}
